import { createFileRoute } from "@tanstack/react-router";
import { FollowUpsPage } from "@/features/follow-ups/FollowUpsPage";

export const Route = createFileRoute("/_app/deals/follow-ups")({
  component: () => <FollowUpsPage search={{}} />,
});
